import StripeConnectorPage from "@app/pages/stripe-connector/stripe-connector-page";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";

export const Route = createFileRoute("/_authed/stripe")({
  head: () => pageHead("Stripe"),
  component: StripeConnectorRoute,
});

function StripeConnectorRoute() {
  return (
    <ErrorBoundary
      fallback={
        <div className="p-6 text-red-500">
          Error loading the Stripe connector
        </div>
      }
    >
      <Suspense
        fallback={
          <div className="p-6 text-gray-500">
            Inspecting the Stripe connector...
          </div>
        }
      >
        <StripeConnectorPage />
      </Suspense>
    </ErrorBoundary>
  );
}
